module.exports = __webpack_public_path__ + "img/Img28_208234_1QU2126-27-173.6c43020a.jpg";